// ============================================================================
// DOMINATOR TREE - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'dominator-tree',
  name: 'Dominator Tree',
  category: 'Graphs',
  complexity: {
    time: 'O(E log V)',
    space: 'O(V + E)'
  },
  description: 'A data structure that represents the dominance relationships in a flow graph. A vertex d dominates vertex v if every path from the entry node to v must pass through d. Used in compiler optimization.'
};
